<template>
  <div ref="appListSkeletonRef" class="app-list-skeleton-root">
    <div v-for="(undefined, index) in cardSize" :key="index" class="app-card"></div>
  </div>
</template>

<script setup lang="ts">
import { useResizeObserver, useThrottleFn } from '@vueuse/core';
import { nextTick, onBeforeUnmount, onMounted, ref } from 'vue';

const CARD_WIDTH = 262 + 16;
const CARD_HEIGHT = 116 + 12;

const appListSkeletonRef = ref<HTMLElement | null>(null);
/** 当前可显示的卡片数 */
const cardSize = ref<undefined[]>([]);

const getRowColumnSize = () => {
  const { width, height } = appListSkeletonRef.value?.getBoundingClientRect() || {};
  let columnNumber = 0;
  let rowNumber = 0;
  if (!width || !height) {
    return { columnSize: columnNumber, rowSize: rowNumber };
  }

  columnNumber = Math.floor(width / CARD_WIDTH);
  rowNumber = Math.floor(height / CARD_HEIGHT);

  return { columnNumber, rowNumber };
};

const setCardSize = () => {
  const { columnNumber, rowNumber } = getRowColumnSize();
  if (!columnNumber || !rowNumber) {
    return;
  }

  const val = columnNumber * rowNumber;

  cardSize.value = new Array(val);
};

let resizeOb: ReturnType<typeof useResizeObserver>;
onMounted(() => {
  // 监测容器大小变化
  resizeOb = useResizeObserver(
    appListSkeletonRef.value,
    useThrottleFn(() => {
      // 清空数据 重新计算
      cardSize.value.splice(0);
      nextTick(() => {
        setCardSize();
      });
    }, 500)
  );
});

onBeforeUnmount(() => {
  resizeOb?.stop?.();
});
</script>

<style lang="scss" scoped>
.app-list-skeleton {
  &-root {
    // display: flex;
    // flex-wrap: wrap;
    // align-content: flex-start;
    // height: 100%;
    position: absolute;
    top: 8px;
    bottom: 0;
    left: 24px;
    right: 24px;
    z-index: 1;

    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(262px, 1fr));
    grid-template-rows: repeat(auto-fill, 116px);
    row-gap: 16px;
    -moz-column-gap: 16px;
    column-gap: 16px;

    .app-card {
      flex: none;
      // width: 262px;
      height: 116px;
      background: #ffffff;
      border-radius: 8px;
      // margin-right: 16px;
      // margin-bottom: 16px;
      background: linear-gradient(
        90deg,
        var(--lowcode-status-02) 25%,
        var(--lowcode-status-03) 37%,
        var(--lowcode-status-02) 63%
      );
      background-size: 400% 100%;
      will-change: background-position;
      animation: skeleton-loading 1.4s ease infinite;
    }
  }
}
</style>
